import { getHttpErrorMessage } from 'utils/http';

const EXPORT_CONTENT_TYPES = ['application/pdf', 'text/csv'];

export async function getBlobHttpErrorMessage(error) {
  const { response } = error || {};
  if (response?.data instanceof Blob) {
    try {
      const text = await response.data.text();
      const data = JSON.parse(text);
      return getHttpErrorMessage({ response: { data } }, false);
    } catch {
      // Fall through to default error parsing.
    }
  }
  return getHttpErrorMessage(error, false);
}

export function downloadResponseBlob(response, fallbackFilename) {
  const contentType = response.headers?.['content-type'] || '';
  const mimeType = contentType.split(';')[0].trim();
  if (!EXPORT_CONTENT_TYPES.some((type) => mimeType.includes(type))) {
    throw new Error('Unexpected export response type');
  }

  const blob = new Blob([response.data], { type: mimeType || 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const contentDisposition = response.headers?.['content-disposition'] || '';
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  link.setAttribute('download', filenameMatch?.[1] || fallbackFilename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Opens a placeholder tab. Call this directly from the click handler: browsers
 * only allow window.open while the user gesture is still active, which is no
 * longer true once the export request has been awaited.
 */
export function openBlankPrintTab() {
  return window.open('', '_blank');
}

/**
 * Shows a PDF response in the browser's PDF viewer, where staff use the
 * viewer's print control. Chrome serves blob PDFs from its own extension
 * origin, so the embedding page cannot call print() on them itself.
 */
export function openPdfResponseInTab(response, printTab) {
  const contentType = response.headers?.['content-type'] || '';
  const mimeType = contentType.split(';')[0].trim();
  if (mimeType !== 'application/pdf') {
    throw new Error('Unexpected print response type');
  }

  const blob = new Blob([response.data], { type: mimeType });
  // Not revoked: the URL has to outlive this call for the viewer tab to load it.
  const url = window.URL.createObjectURL(blob);

  if (printTab && !printTab.closed) {
    printTab.location.href = url;
    printTab.focus();
    return true;
  }

  return Boolean(window.open(url, '_blank'));
}
